var map = {
	"./cars.svg": "a54f",
	"./community.svg": "ec97",
	"./empty.svg": "0afe",
	"./logo-b.svg": "5c71",
	"./logo.svg": "1ae4",
	"./m-logo.svg": "7a11",
	"./notFound.svg": "dca0",
	"./touch.svg": "9053"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";